export const GLPagePropertyTypeList = [
    {
      id: "fOQZ4CPJQYZikZnFkrxy",
      label: "Layout",
    },

    // {
    //   id: "xOl7nFLzvXtqVAcSrvIC",
    //   label: "Apartment",
    // },

    {
      id: "k6QfCzo0QVXutC3MUTfV",
      label: "Villa",
    },
  ];